export default (params) => ({
  trigger: {
    name: 'add_to_cart_page.go_to_shopping_cart',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'employee_atc_page',
          'customer_atc_page',
          'customer_atc_page_popover',
          'business_atc_page',
          'employee_atc_page_popover',
        ],
      },
    },
    event: {
      name: 'order',
    },
  },
});
